export var createMuiTextFieldOverrides = function () {
    return {
        defaultProps: {
            SelectProps: {
                native: true,
            },
            variant: 'outlined',
            fullWidth: false,
        },
    };
};
